import { useState, useEffect } from "react";
import "./styles/PanelConfig.css";
import Search from "../generales/Search";
import Modal from "react-modal";
// import Action from "../Action";
import Action from "../Action";
import LoadSimple from "../LoadSimple";
import TableHosts from "./Hosts/TableHosts";
import InfoPortafolio from "./Criticidad/InfoPortafolio";
import Paginador from "../generales/Paginador";
import ModalCreateHost from "./Hosts/ModalCreateHost";
import ImportInfo from "./Hosts/ImportInfo";
import UpdateInfo from "./Hosts/UpdateInfo";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import ModalMenuHost from "./Hosts/ModalMenuHost";
import Discovery from "./Hosts/Discovery";
import ModalDeleteMasive from "./Hosts/ModalDeleteMasive";
import { permisos_codigo_id } from "../generales/GroupsId";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '60%',
    padding: '20px'
  },
};
const ImportModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    padding: "20px",
  },
};
const DiscoveryModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "95%",
    padding: "20px",
  },
};
const PanelHosts = ({ server, languaje, mode, handleShowPopup, userPermissions }) => {
  // const limitList = 200;
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [ActualizarModalOpen, setActualizarModalOpen] = useState(false);
  const [DiscoveryModalOpen, setDiscoveryModalOpen] = useState(false);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  // console.log(userPermissions);
  const [searchResult, setSearchResult] = useState(null);
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);
  const [groupSelected, setgroupSelected] = useState([])
  const [poolRows, setPoolRows] = useState([])
  const [poolObjectRows, setPoolObjectRows] = useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [exportLoading, setExportLoading] = useState(false)
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setPoolObjectRows([])
    setPoolRows([])
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  function closCreateCisModal() {
    if (!editActive) {
      setSearchTerm("")
    }

    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const import_info = () => {
    setImportModalOpen(true);
  };
  function closeImportModal() {
    setSearchTerm("")
    setImportModalOpen(false);
    setAllSelected(false)
    setPoolRows([])
  }
  const actualizar_info = () => {
    setActualizarModalOpen(true);
  };
  function closeActualizarModal() {
    setSearchTerm("")
    setActualizarModalOpen(false);
    setAllSelected(false)
    setPoolRows([])
  }
  const openDiscovery = () => {
    setDiscoveryModalOpen(true);
  };
  function closeDiscoveryModal() {
    setSearchTerm("")
    setDiscoveryModalOpen(false);
  }
  const handleChangEdit = (element) => {
    setgroupSelected(element)
    setEditActive(true);
    setCreateCisModalOpen(true)
  };
  useEffect(() => {
    buscar_cis();
  }, []);


  const buscar_cis = () => {
    setSearchTerm("")
    setLoadingList(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/hosts/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setLoadingList(false)
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };


  const Exportar = (file_type) => {

    let method = 'POST'
    const body = {
      "file_type": file_type,
      "hostids": poolRows
    }
    setExportLoading(true)
    const fetchDataPost = async () => {

      try {
        // console.log(localStorage.getItem('access_token'))
        const response = await fetch(server.url + '/api/v1/cassia/hosts/export', {
          method: method,
          headers: {
            "Accept": "application/json",
            // 'Content-Type': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify(body),
        });
        if (response.ok) {
          // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // Dependiendo del tipo de archivo, nombramos el archivo a descargar
          if (file_type === 'json') {
            link.download = 'Hosts.json';
          } else if (file_type === 'csv') {
            link.download = 'Hosts.csv';
          } else if (file_type === 'excel') {
            link.download = 'Hosts.xlsx'; // Archivo de Excel
          }

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setAllSelected(false)
          setPoolRows([])
          setExportLoading(false);
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])), '', true)
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {

      }
    };

    fetchDataPost();

  }
  const ExportarSNMP = (file_type) => {

    let method = 'GET'
    const body = {
      "file_type": file_type,
      "hostids": poolRows
    }
    setExportLoading(true)
    const fetchDataPost = async () => {

      try {
        // console.log(localStorage.getItem('access_token'))
        const response = await fetch(server.url + '/api/v1/cassia/hosts/reportes/reporte_snmp', {
          method: method,
          headers: {
            "Accept": "application/json",
            // 'Content-Type': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          // body: JSON.stringify(body),
        });
        if (response.ok) {
          // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // Dependiendo del tipo de archivo, nombramos el archivo a descargar
          if (file_type === 'json') {
            link.download = 'Hosts.json';
          } else if (file_type === 'csv') {
            link.download = 'Hosts.csv';
          } else if (file_type === 'excel') {
            link.download = 'Reporte_SNMP' + obtenerFechaActualLocal() + '.xlsx'; // Archivo de Excel
          }

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setAllSelected(false)
          setPoolRows([])
          setExportLoading(false);
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])), '', true)
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {

      }
    };

    fetchDataPost();

  }
  const handleSelectChange = (e) => {
    setLimitList(e.target.value); setPageActual(1);
  };

  const [importLoading, setImportLoading] = useState(false);
  return (
    <>
      <div className='head-cis'>
        <div className='title-cis'>
          <Search
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            onSearch={handleSearch}
            dataObject={dataUsers.data}
            setDataObject={setDataUsers}
            searchResult={searchResult}
            setSearchResult={setSearchResult}
            languaje={languaje}
          />
          <div className={"cont-result-registers" + mode}>

            <p style={{ textAlign: "center" }}>
              &nbsp;
              {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados']) + " (" +
                dataList.length +
                ") "
              }
            </p>
          </div>
          {/* <div className="cont-buttons-panel">

            {userPermissions.some(
              (objeto) => objeto.permission_id === permisos_codigo_id["crear dispositivo"]
            ) ? <Action
              disabled={false}
              origen="Azul"
              titulo={"+ " + capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
              action={crear}
            /> : ''}


          </div>
          <div className="cont-buttons-panel" style={{ right: '15%' }}>




            {userPermissions.some(
              (objeto) => objeto.permission_id === permisos_codigo_id["crear dispositivo"]
            ) ? <Action
              disabled={false}
              origen="Cielo"
              titulo={" " + capitalizeFirstLetter(lang[languaje]['importar'])}
              action={import_info}
            /> : ''}

          </div>
          <div className="cont-buttons-panel" style={{ right: '15%', top: '50%' }}>




            <Action
              disabled={false}
              origen="Cielo"
              titulo={" " + capitalizeFirstLetter(lang[languaje]['actualizar'])}
              action={actualizar_info}
            />
          </div>
          <div className="cont-buttons-panel" style={{ top: '50%' }}>




            <Action
              disabled={false}
              origen="Cielo"
              titulo={" " + capitalizeFirstLetter(lang[languaje]['discovery'])}
              action={openDiscovery}
            />

          </div> */}
        </div>

      </div>
      <div className='cont-cis'>
        <>
          <div className="main-panel-cis">
            <div className="compact-content-portafolio">
              <div className={"content-portafolio-head" + mode}>
                {
                  // (contRowsSelected!=0)?
                  <>
                    {(exportLoading) ? <div className="cont-excels-buttons-portafolio cont-result-registers" style={{ position: 'absolute' }}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div> :
                      <>
                        {/* {(contRowsSelected==0)?<div className="cont-excels-buttons-portafolio" style={{position:'absolute',background:'#62626233',zIndex:'2'}}></div>:''} */}
                        {/* <div className="cont-excels-buttons-portafolio" style={{ position: 'absolute', left: '40%' }}>
                          <div className="full-excels-buttons-portafolio" style={{ width: '100%' }}>

                            <div className="body-half-excels-buttons-portafolio">
                              {

                                <img
                                  className="img-full-dwnld-portafolio"
                                  // style={{width:'20%'}}
                                  src={"/iconos/xsl_icon.png"}
                                  name="regresar"
                                  onClick={() => ExportarSNMP('excel')}

                                />
                              }
                            </div>
                            <div className={"top-half-excels-buttons-portafolio" + mode} >
                              {capitalizeFirstLetter(lang[languaje]['reporteSNMP'])}
                            </div>
                          </div>


                        </div> */}
                        {/* <div className="cont-excels-buttons-portafolio" style={{ position: 'absolute' }}>
                          {userPermissions.some(
                            (objeto) => objeto.permission_id === permisos_codigo_id["eliminar dispositivo"]
                          ) ?
                            <div className="half-excels-buttons-portafolio">

                              <div className="body-half-excels-buttons-portafolio">
                                {

                                  <img
                                    className="img-dwnld-portafolio"
                                    src={"/iconos/delete.png"}
                                    name="regresar"
                                    onClick={() => openDeleteUserModal()}
                                    style={{
                                      opacity: (contRowsSelected == 0) ? '0.3' : '1',
                                      pointerEvents: (contRowsSelected == 0) ? 'none' : 'auto'
                                    }}
                                  />
                                }
                              </div>
                              <div className={"top-half-excels-buttons-portafolio" + mode} >
                                {capitalizeFirstLetter(lang[languaje]['eliminar'])}
                              </div>
                            </div> : ''}


                        </div> */}
                        <div className="cont-excels-buttons-portafolio" style={{ position: 'absolute', left: '60%' }}>
                          <div className="half-excels-buttons-portafolio">

                            <div className="body-half-excels-buttons-portafolio">
                              {

                                <img
                                  className="img-dwnld-portafolio"
                                  src={"/iconos/csv_icon.png"}
                                  name="regresar"
                                  onClick={() => Exportar('csv')}
                                  style={{
                                    opacity: (contRowsSelected == 0) ? '0.3' : '1',
                                    pointerEvents: (contRowsSelected == 0) ? 'none' : 'auto'
                                  }}
                                />
                              }
                            </div>
                            <div className={"top-half-excels-buttons-portafolio" + mode} >
                              {'CSV  '}
                            </div>
                          </div>
                          <div className="half-excels-buttons-portafolio">

                            <div className="body-half-excels-buttons-portafolio">
                              {

                                <img
                                  className="img-dwnld-portafolio"
                                  src={"/iconos/json_icon.png"}
                                  name="regresar"
                                  onClick={() => Exportar('json')}
                                  style={{
                                    opacity: (contRowsSelected == 0) ? '0.3' : '1',
                                    pointerEvents: (contRowsSelected == 0) ? 'none' : 'auto'
                                  }}
                                />
                              }
                            </div>
                            <div className={"top-half-excels-buttons-portafolio" + mode} >
                              {'JSON'}
                            </div>
                          </div>
                          <div className="half-excels-buttons-portafolio">

                            <div className="body-half-excels-buttons-portafolio">
                              {

                                <img
                                  className="img-dwnld-portafolio"
                                  src={"/iconos/xsl_icon.png"}
                                  name="regresar"
                                  onClick={() => Exportar('excel')}
                                  style={{
                                    opacity: (contRowsSelected == 0) ? '0.3' : '1',
                                    pointerEvents: (contRowsSelected == 0) ? 'none' : 'auto'
                                  }}
                                />
                              }
                            </div>
                            <div className={"top-half-excels-buttons-portafolio" + mode} >
                              {'EXCEL'}
                            </div>
                          </div>
                        </div>
                      </>
                    }
                  </>
                  // :''
                }
              </div>
              <div className="content-portafolio">
                <div className="cont-portafolio-table">
                  <div className="content-card-portafolio" id="content">
                    {(exportLoading || importLoading) ? (
                      <LoadSimple />
                    ) : (
                      <>
                        {cisSelected.length === 0 ? (
                          <TableHosts
                            pageActual={pageActual}
                            limitList={limitList} startLimit={startLimit}
                            dataList={dataList}
                            cisSelected={cisSelected}
                            setCisSelected={setCisSelected}
                            registerIsValid={registerIsValid}
                            searchResults={searchResults}
                            setSearchResults={setSearchResults}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            dataUsers={dataUsers}
                            setDataUsers={setDataUsers}
                            server={server}
                            setRegisterIsValid={setRegisterIsValid}
                            setData={setData}
                            setLoading={setLoading}
                            setError={setError}
                            handleChangEdit={handleChangEdit}
                            devices={devices}
                            languaje={languaje}
                            mode={mode}
                            setContRowSelected={setContRowSelected}
                            poolRows={poolRows}
                            setPoolRows={setPoolRows}
                            allSelected={allSelected}
                            setAllSelected={setAllSelected}
                            handleShowPopup={handleShowPopup}
                            buscar_cis={buscar_cis}
                            loadingList={loadingList}
                            setPoolObjectRows={setPoolObjectRows}
                            poolObjectRows={poolObjectRows}
                            userPermissions={userPermissions}
                          ></TableHosts>
                        ) : (
                          ("")
                          // <InfoPortafolio
                          //   server={server}
                          //   portfolioSelected={cisSelected}
                          //   searchResults={searchResults}
                          //   setSearchResults={setSearchResults}
                          //   searchTerm={searchTerm}
                          //   setSearchTerm={setSearchTerm}
                          //   onSearch={handleSearch}
                          //   dataUsers={dataUsers}
                          //   setDataUsers={setDataUsers}
                          //   setCisSelected={setCisSelected}
                          //   registerIsValid={registerIsValid}
                          // ></InfoPortafolio>
                        )}
                      </>
                    )}
                  </div>
                </div>

              </div>
              <div className={"content-portafolio-footer" + mode}>
                <div className="cont-display-paginador" style={{ position: 'absolute', left: '0%', justifyContent: 'start' }}>

                  <div className={"cont-half-display-paginador" + mode}>
                    <p style={{ textAlign: "center" }}>
                      &nbsp;
                      {(contRowsSelected != 0) ? "(" + contRowsSelected + ")  " + capitalizeFirstLetter(lang[languaje]['registosSeleccionados']) : ''}
                    </p>

                  </div>
                </div>
                <div className="cont-display-paginador">
                  <Paginador pages={pages}
                    pageActual={pageActual}
                    setPageActual={setPageActual}
                    mode={mode}></Paginador>
                </div>
                <div className="cont-display-paginador">
                  <div className={"cont-half-display-paginador" + mode}>

                    <div>
                      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
                        <option value={10}>10</option>
                        <option value={50} >50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                      </select>


                    </div>
                  </div>
                  <div className={"cont-half-display-paginador" + mode}>
                    <p style={{ textAlign: "center" }}>
                      &nbsp;
                      {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length > parseInt(pageActual) * parseInt(limitList)
                          ? parseInt(pageActual) * parseInt(limitList)
                          : dataList.length) +
                        ")  " + lang[languaje]['de'] + " " +
                        dataList.length +
                        " " + lang[languaje]['resultados']}
                    </p>

                  </div>
                </div>

              </div>
            </div>
          </div>
          <Modal
            isOpen={CreateCisModalOpen}
            // isOpen={false}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closCreateCisModal}
            style={CreateCisModalStyles}
            contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
          >
            <ModalMenuHost
              devices={devices}
              server={server}
              editActive={editActive}
              setEditActive={setEditActive}
              dataCis={dataCis}
              setData={setData}
              loading={loading}
              setLoading={setLoading}
              setError={setError}
              dataUsers={dataUsers}
              setRegisterIsValid={setRegisterIsValid}
              closCreateCisModal={closCreateCisModal}
              groupSelected={groupSelected}
              languaje={languaje}
              mode={mode}
              setSearchTerm={setSearchTerm}
              handleShowPopup={handleShowPopup}
              buscar_cis={buscar_cis}
            ></ModalMenuHost>
          </Modal>

          <Modal
            isOpen={ImportModalOpen}
            // isOpen={false}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closeImportModal}
            style={ImportModalStyles}
            contentLabel="Example Modal2"
            shouldCloseOnOverlayClick={false}
          >
            <ImportInfo
              server={server}
              importLoading={importLoading}
              setImportLoading={setImportLoading}
              closeImportModal={closeImportModal}
              languaje={languaje}
              mode={mode}
              handleShowPopup={handleShowPopup}
              buscar_cis={buscar_cis}
            ></ImportInfo>
          </Modal>
          <Modal
            isOpen={ActualizarModalOpen}
            // isOpen={false}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closeActualizarModal}
            style={ImportModalStyles}
            contentLabel="Example Modal2"
            shouldCloseOnOverlayClick={false}
          >
            <UpdateInfo
              server={server}
              importLoading={importLoading}
              setImportLoading={setImportLoading}
              closeImportModal={closeActualizarModal}
              languaje={languaje}
              mode={mode}
              handleShowPopup={handleShowPopup}
              buscar_cis={buscar_cis}
            ></UpdateInfo>
          </Modal>
          <Modal
            isOpen={DiscoveryModalOpen}
            // isOpen={false}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closeDiscoveryModal}
            style={DiscoveryModalStyles}
            contentLabel="Example Modal2"
            shouldCloseOnOverlayClick={false}
          >
            <Discovery
              server={server}
              importLoading={importLoading}
              setImportLoading={setImportLoading}
              closeDiscoveryModal={closeDiscoveryModal}
              languaje={languaje}
              mode={mode}
              handleShowPopup={handleShowPopup}
              buscar_cis={buscar_cis}
            ></Discovery>
          </Modal>
          <Modal
            isOpen={deleteUserModalOpen}
            // isOpen={true}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closDeleteUserModal}
            style={deleteUserModalStyles}
            contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
          >
            <ModalDeleteMasive handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} poolObjectRows={poolObjectRows} closDeleteUserModal={closDeleteUserModal}></ModalDeleteMasive>
          </Modal>
        </>

      </div>
    </>
  );
};

export default PanelHosts;
